import React, { Component, Fragment } from "react";
import "./sizing.css";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";
import { getGasPistoonTypes } from "../../constants/sizing-constant";

import GasPistoonCNGSizing from "../sizing/GasPistoonCNGSizing";
import GasPistoonOtherGasSizing from "../sizing/GasPistoonOtherGasSizing";

export default class GasPistonSizing extends Component {

    state = {
        gasPistoonTypes: [],
        selectedGasPistoonType: "0",

        suggestedModel: "",
        suggestedModelId: "",
        sentrifuge: []
    };

    componentDidMount() {
        this.setState({ gasPistoonTypes: [...getGasPistoonTypes()] });
    }

    handleGasPistoonTypesSelect = gasPistoonType => {
        if (gasPistoonType) {
            this.setState({ selectedGasPistoonType: gasPistoonType.value }, () => {

            });
        }
    };

    render() {
        return (
            <Fragment>
                <DropDownWhiteStyle
                    items={this.state.gasPistoonTypes}
                    placeholder="نوع خروجی"
                    onItemSelect={this.handleGasPistoonTypesSelect}
                    value={this.state.selectedGasPistoonType}
                />
                {this.state.selectedGasPistoonType === "1" &&
                    <GasPistoonCNGSizing />
                }
                {this.state.selectedGasPistoonType === "2" &&
                    <GasPistoonOtherGasSizing />
                }
            </Fragment>
        );
    }
}
